import { useState } from "react";

import {
    Button,
    Input,
    InputGroup
} from "reactstrap";

import {
    SendHorizonal, 
} from "lucide-react";

interface Props {

    onSend: (message: string) => void;

    replyToMessage?: string;

    replyToUser?: string;

    onCancelReply?: () => void;

}

const MessageInput = ({
    onSend,
    replyToMessage,
    replyToUser,
    onCancelReply
}: Props) => {

    const [message, setMessage] =
        useState("");

    const send = () => {

        if (!message.trim())
            return;

        onSend(message);

        setMessage("");

    };

    const handleKeyDown = (
        e: React.KeyboardEvent<HTMLInputElement>
    ) => {

        if (
            e.key === "Enter" &&
            !e.shiftKey
        ) {

            e.preventDefault();

            send();

        }

    };

    return (

        <div className="border-top p-3">

            {replyToMessage && (

                <div
                    className="bg-light rounded p-2 mb-3"
                >

                    <div  className="d-flex justify-content-between">

                        <div>

                            <strong>

                                Replying to {replyToUser}

                            </strong>

                            <div>

                                {replyToMessage}

                            </div>

                        </div>

                        <Button
                            close
                            onClick={onCancelReply}
                        />

                    </div>

                </div>

            )}

            <InputGroup>

                {/* <Button
                    color="light"
                >

                    <Smile size={20} />

                </Button>

                <Button
                    color="light"
                >

                    <Paperclip size={20} />

                </Button> */}

                <Input
                    placeholder="Type your message..."
                    value={message}
                    onChange={(e) =>
                        setMessage(
                            e.target.value
                        )
                    }
                    onKeyDown={handleKeyDown}
                />

                <Button
                    color="primary"
                    onClick={send}
                >

                    <SendHorizonal size={18} />

                </Button>

            </InputGroup>

        </div>

    );

};

export default MessageInput;